var render, staticRenderFns
import script from "./NormalMask.vue?vue&type=script&lang=js"
export * from "./NormalMask.vue?vue&type=script&lang=js"
import style0 from "./NormalMask.vue?vue&type=style&index=0&id=1d56e404&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56e404",
  null
  
)

export default component.exports